import React, { useContext, useEffect, useState } from "react";
import {
  FaMoneyBill,
  FaProjectDiagram,
  FaTasks,
  FaUserCircle,
} from "react-icons/fa";
import { MdGroup } from "react-icons/md";
import { IoIosPersonAdd, IoMdMail } from "react-icons/io";
import {
  Chart,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Pie, Bar, Line } from "react-chartjs-2";
import { Link } from "react-router-dom";
import { FcNext, FcPrevious } from "react-icons/fc";
import { Row } from "react-bootstrap";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { ViewProjectadmindash } from "./Salarytable";
import { GlobalContext } from "../../Context/GlobalState";
Chart.register(
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
  Legend
);
const AdminDashboard = () => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  // console.log(user);
  const [absent, setabsent] = useState([]);
  const [BarData, setBarData] = useState([]);
  const [employeeCounts, setEmployeeCounts] = useState([]);
  const [employeebirth, setemployeebirth] = useState([]);
  const [projectcount, setprojectcount] = useState([]);
  const [interns, setInterns] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [Department, setDepartment] = useState([]);
  const [dashboard, setDashboard] = useState(null);
  const { password, username } = billpunchbasicauth;
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };
  const getDepartmentList = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({ firmid: user.firm_id });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployeeDepartment`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setDepartment(data?.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
  };
  const getEmployeebirthday = async () => {
 
    setTransactionLoaderState(true);

    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployee`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            firmId: user.firm_id,
          }),
        }
      );

      const data = await res.json();

      if (data.status === "0" && Array.isArray(data.data)) {
        setemployeebirth(data.data);

        localStorage.setItem(
          "employeeBirthdayDataadmin",
          JSON.stringify({ data: data.data })
        );

        const internsData = data.data.filter(
          (employee) => employee?.emp_type === "Intern"
        );
        const employeesData = data.data.filter(
          (employee) => employee?.emp_type !== "Intern"
        );

        setInterns(internsData);
        setEmployees(employeesData);
      } else {
        console.warn(" API returned no valid employee data");
      }
    } catch (error) {
      console.error("ERROR :", error);
    } finally {
      setTransactionLoaderState(false);
    
    }
  };

  const Getprojectcount = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firmid: user.firm_id,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetProjectCount`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setprojectcount(data?.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const getEmployeeCount = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeeCountDash`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            firmid: user.firm_id,
          }),
        }
      );

      const data = await res.json();
      if (data.status === "0") {
        setEmployeeCounts(data?.data[0]);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const labelsMap = {
    it_employees: "IT",
    sales_employees: "Sales",
    digital_employees: "Digital",
    customer_support: "Customer Support",
    accounts: "Accounts",
    other: "Other",
  };

  const chartLabels = Object.keys(employeeCounts).map((key) => labelsMap[key]);
  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        data: Object.values(employeeCounts),
        backgroundColor: [
          "#9AD0C2",
          "#41C9E2",
          "#FEC7B4",
          "#B0C5A4",
          "#BFEA7C",
          "#FFF67E",
        ],
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
  };
  const barOptions = {
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
        },
      ],
    },
  };

  const currentMonth = new Date()?.getMonth() + 1;
  const filteredBirthdays = employeebirth.filter((birth) => {
    const birthMonth = new Date(birth?.dob).getMonth() + 1;
    return birthMonth === currentMonth;
  });

  const GetPayoutMonthly = async () => {
    try {
      setTransactionLoaderState(true);
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({
        firmid: user.firm_id,
        month: "0",
        year: selectedYear.toString(),
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetPayoutDashboard`,
        requestOptions
      );
      const responseData = await res.json();

      if (responseData.status === "0") {
        const formattedData = {
          labels: [],
          datasets: [
            {
              label: "Total Intern Salary",
              data: [],
              backgroundColor: "rgba(54, 162, 235, 1)",
              borderColor: "rgba(54, 162, 235, 1)",
              borderWidth: 1,
            },
            {
              label: "Total Full Time Salary",
              data: [],
              backgroundColor: "rgba(54, 233, 235, 19)",
              borderColor: "rgba(54, 162, 235, 1)",
              borderWidth: 1,
            },
          ],
        };

        responseData.data.forEach((monthData) => {
          formattedData.labels.push(monthData.month);
          formattedData.datasets[0].data.push(
            parseFloat(monthData?.totalInternSalary)
          );
          formattedData.datasets[1].data.push(
            parseFloat(monthData?.totalFullTimeSalary)
          );
        });

        setBarData(formattedData);
      } else {
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const GetAllEmployeeLeave = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmid: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetAllEmployeeLeave`,
        requestOptions
      );
      const leave = await res.json();
      if (leave.status === "0") {
        setabsent(leave?.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    getEmployeebirthday();
    getEmployeeCount();
    GetAllEmployeeLeave();
    Getprojectcount();
    getDepartmentList();
    // getAccessData();
  }, []);
  useEffect(() => {
    GetPayoutMonthly();
  }, [selectedYear]);

  const months = [
    { value: "January", name: "January" },
    { name: "February", value: "February" },
    { name: "March", value: "March" },
    { name: "April", value: "April" },
    { name: "May", value: "May" },
    { name: "June", value: "June" },
    { name: "July", value: "July" },
    { name: "August", value: "August" },
    { name: "September", value: "September" },
    { name: "October", value: "October" },
    { name: "November", value: "November" },
    { name: "December", value: "December" },
  ];

  const [selectedMonth, setSelectedMonth] = useState("January");
  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };
  useEffect(() => {
    const getEmployeegenerateddashboard = async () => {
      try {
        setTransactionLoaderState(true);
        const base64Credentials = btoa(`${username}:${password}`);

        const raw = JSON.stringify({
          month: selectedMonth,
          firmid: user.firm_id,
          year: String(new Date().getFullYear()),
        });

        const requestOptions = {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: raw,
          redirect: "follow",
        };

        const res = await fetch(
          `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFixedExpenseDashboard`,
          requestOptions
        );
        const responseData = await res.json();

        if (responseData.status === "0") {
          const dashboardData = responseData?.data[0] || {};
          setDashboard(dashboardData);
        } else {
          setDashboard({ yourDataProperty: 0 });
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        setTransactionLoaderState(false);
      }
    };

    getEmployeegenerateddashboard();
  }, [selectedMonth]);
  const formatDateWithoutYear = (date) => {
    return new Date(date)?.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
    });
  };
  return (
    <>
      <div style={{ background: "#fff" }}>
        <h5 className="px-md-4  mt-4 pt-2 pb-0">Welcome Admin Dashboard!</h5>
        {/* <div className="tagline-marquee">
          <p>Your Tagline Goes Here — Bringing You the Best Campaigns!</p>
        </div>{" "}
        <div className="tagline-marquee mt-1">
          <p>Your Tagline Goes Here — Bringing You the Best Campaigns!</p>
        </div> */}
        <div className="row pb-2 pt-2 px-3">
          <div className="col">
            <div
              className="card m-0 p-md-2 p-2"
              style={{ boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" }}
            >
              <div className="row m-0 p-0">
                <div className="col d-flex align-items-center">
                  {" "}
                  <FaProjectDiagram
                    style={{ fontSize: "1.5rem", color: "#7EA1FF" }}
                  />
                </div>
                <div className="col">
                  <p style={{ fontSize: ".9rem" }} className="m-0 p-0">
                    Projects
                  </p>
                  <h6 className="m-0 p-0">
                    {projectcount?.length > 0
                      ? projectcount[0]?.project_count
                      : "Loading..."}
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div
              className="card m-0 p-md-2 p-2"
              style={{ boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" }}
            >
              <div className="row m-0 p-0">
                <div className="col d-flex align-items-center">
                  <IoIosPersonAdd
                    style={{ fontSize: "1.5rem", color: "#7EA1FF" }}
                  />
                </div>
                <div className="col">
                  <p style={{ fontSize: ".9rem" }} className="m-0 p-0">
                    Intern
                  </p>
                  <h6 className="m-0 p-0">{interns?.length}</h6>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div
              className="card m-0 p-md-2 p-2"
              style={{ boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" }}
            >
              <div className="row m-0 p-0">
                <div className="col d-flex align-items-center">
                  <MdGroup style={{ fontSize: "1.5rem", color: "#7EA1FF" }} />
                </div>
                <div className="col">
                  <p style={{ fontSize: ".9rem" }} className="m-0 p-0">
                    Employee
                  </p>
                  <h6 className="m-0 p-0">{employees?.length}</h6>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div
              className="card m-0 p-md-2 p-2"
              style={{ boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" }}
            >
              <div className="row m-0 p-0">
                <div className="col d-flex align-items-center">
                  <FaTasks style={{ fontSize: "1.5rem", color: "#7EA1FF" }} />
                </div>
                <div className="col">
                  <p style={{ fontSize: ".9rem" }} className="m-0 p-0">
                    Department
                  </p>
                  <h6 className="m-0 p-0">{Department?.length}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row pt-1 pb-1 px-3 ">
          <div className="col-md-3 col-6">
            <div
              className="card m-0 p-2 text-center h-100"
              style={{
                border: "1px dotted grey",
                // height: "55vh",
                overflow: "hidden",
              }}
            >
              <h6 className="text-center">Expense Payout</h6>
              <div
                className="scrollable-content"
                style={{
                  height: "100%",
                  overflowY: "auto",
                  scrollbarWidth: "thin",
                  scrollbarColor: "transparent transparent",
                }}
              >
                <div className="row p-0 mb-1">
                  <h6 className="col">{selectedMonth}</h6>
                  <div className="col">
                    <select
                      style={{
                        width: "5rem",
                        height: "1.5rem",
                        borderRadius: ".4rem",
                        border: "1px #ced4da solid",
                      }}
                      value={selectedMonth}
                      onChange={handleMonthChange}
                    >
                      {months.map((month) => (
                        <option key={month?.value} value={month?.value}>
                          {month?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div>
                  <FaMoneyBill style={{ color: "teal", fontSize: "1.5rem" }} />
                </div>
                <div style={{ fontSize: ".9rem" }}>Total Generated</div>
                <h6>{parseFloat(dashboard?.total_generated) || 0}</h6>
                <hr className="m-1" />
                <div>
                  <FaMoneyBill style={{ color: "teal", fontSize: "1.5rem" }} />
                </div>
                <div style={{ fontSize: ".9rem" }}>Total Processed</div>
                <h6>{parseFloat(dashboard?.processed) || 0}</h6>
                <hr className="m-1" />
                <div>
                  <FaMoneyBill style={{ color: "teal", fontSize: "1.5rem" }} />
                </div>
                <div style={{ fontSize: ".9rem" }}>Total Unprocessed</div>
                <h6>{parseFloat(dashboard?.unprocessed) || 0}</h6>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-6 d-flex flex-column align-items-center">
            <div className="m-0 p-2 mb-1">
              <h6 className="text-center">Employees</h6>
            </div>
            <div className="d-flex justify-content-center">
              <div style={{ width: "200px", height: "200px" }}>
                <Pie data={chartData} options={options} />
              </div>
            </div>
          </div>

          <div className="col-md-6 pt-md-0 pt-3 col">
            <div
              className="card m-0 p-2  d-flex flex-column h-100"
              style={{ border: "1px dotted grey", height: "45vh" }}
            >
              <Row className="pb-0">
                <h6 className="col-4 mb-1">Salary Payout</h6>
                <div className=" col d-flex justify-content-end ">
                  <select
                    value={selectedYear}
                    onChange={handleYearChange}
                    className="form-select w-25"
                    style={{ textAlign: "center" }}
                  >
                    {[...Array(10).keys()].map((offset) => {
                      const year = new Date().getFullYear() - offset;
                      return (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Row>

              <div style={{ flex: 1, position: "relative" }}>
                {BarData &&
                BarData.datasets &&
                BarData.datasets.length > 0 &&
                BarData.datasets[0].data.length > 0 ? (
                  <Bar data={BarData} options={barOptions} />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    No data found
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row px-3 pt-1">
          <div className="col-md-3 col-6">
            <div className="card m-0 p-2" style={{ background: "#fff" }}>
              <div className="row m-0 p-0">
                <div className="col">
                  <img
                    alt=""
                    style={{
                      height: "3rem",
                    }}
                    src={require("../../assets/images/birth5.gif")}
                  />{" "}
                </div>
                <h6 className="col-8 ">
                  {" "}
                  <img
                    alt=""
                    style={{
                      height: "8vh",
                    }}
                    src={require("../../assets/images/birth4.png")}
                  />{" "}
                </h6>
              </div>
              <div
                className="card m-0 p-1"
                style={{ background: "#FFFDCB", border: "1px solid #FFC700" }}
              >
                <p
                  className="m-0 p-0 d-flex justify-content-center"
                  style={{ color: "#124076" }}
                >
                  Take a minute and congratulate them on their special day!
                  <img
                    alt=""
                    style={{
                      height: "1rem",
                    }}
                    src={require("../../assets/images/birth1.png")}
                  />{" "}
                </p>
              </div>
              <div>
                {filteredBirthdays.length === 0 ? (
                  <div
                    style={{
                      textAlign: "center",
                      color: "#673F69",
                      fontSize: "1rem",
                      fontWeight: "600",
                    }}
                  >
                    No data found
                  </div>
                ) : (
                  filteredBirthdays.map((birth, index) => (
                    <div key={index}>
                      <div className="row pt-2 pb-0">
                        <div
                          className="col-5 d-flex justify-content-center"
                          style={{
                            color: "#FBA834",
                            fontSize: ".9rem",
                            fontWeight: "600",
                          }}
                        >
                          {birth?.firstname}
                        </div>
                        <div
                          className="col-5 d-flex justify-content-center"
                          style={{
                            color: "#673F69",
                            fontSize: ".8rem",
                            fontWeight: "600",
                          }}
                        >
                          <span>{formatDateWithoutYear(birth?.dob)}</span>
                        </div>
                        <div className="col-2 m-0 p-0 d-flex justify-content-center">
                          <div
                            style={{
                              position: "relative",
                              display: "inline-block",
                              marginRight: "5px",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              const tooltip =
                                e.currentTarget.querySelector(
                                  ".tooltip-inline"
                                );
                              tooltip.style.visibility = "visible";
                              tooltip.style.opacity = "1";
                            }}
                            onMouseLeave={(e) => {
                              const tooltip =
                                e.currentTarget.querySelector(
                                  ".tooltip-inline"
                                );
                              tooltip.style.visibility = "hidden";
                              tooltip.style.opacity = "0";
                            }}
                          >
                            <a
                              href={`mailto:${birth.work_email}?subject=Warm%20Birthday%20Wishes%20to%20${birth?.firstname}&body=Dear%20${birth?.firstname},%0D%0A%0D%0AHappy%20birthday!%20May%20your%20special%20day%20be%20filled%20with%20joy%20and%20happiness.%20Wishing%20you%20all%20the%20best%20today%20and%20always.%0D%0A%0D%0AWarm%20regards,%0D%0A[Your%20Name]%0D%0A[Your%20Position]%0D%0A[Company%20Name]`}
                            >
                              <IoMdMail
                                style={{ color: "red", fontSize: "1.2rem" }}
                              />
                            </a>
                            <span
                              className="tooltip-inline"
                              style={{
                                position: "absolute",
                                bottom: "125%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                backgroundColor: "#333",
                                color: "#fff",
                                padding: "4px 8px",
                                borderRadius: "4px",
                                fontSize: "0.8rem",
                                whiteSpace: "nowrap",
                                visibility: "hidden",
                                opacity: 0,
                                transition: "opacity 0.3s ease",
                                zIndex: 1,
                              }}
                            >
                              {birth?.work_email}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
          <div className="col-md-6 pt-md-0 pt-3 col">
            <div className="card m-0 p-2">
              {" "}
              <ViewProjectadmindash />
            </div>
          </div>
          <div className="col-md-3 col-8" style={{ background: "#fff" }}>
            <div className="card p-3">
              <h6 className="text-center">Leaves</h6>

              {absent && absent.length > 0 ? (
                absent.slice(0, 3).map((leave, index) => (
                  <div key={index}>
                    <div className="row align-items-center mb-2">
                      <div className="col-2 p-1 d-flex justify-content-center">
                        <FaUserCircle
                          style={{ fontSize: "1.8rem", color: "#41B06E" }}
                        />
                      </div>

                      <div
                        className="col"
                        style={{
                          fontSize: "0.8rem",
                          fontWeight: "500",
                          color: "#444",
                        }}
                      >
                        {leave?.employee_name}
                      </div>

                      <div className="col-auto">
                        {leave?.status === "R" && (
                          <span
                            style={{
                              backgroundColor: "rgba(255, 46, 46, 0.1)",
                              color: "#ff2e2e",
                              border: "1px solid #ff2e2e",
                              borderRadius: "0.2rem",
                              padding: "2px 6px",
                              fontSize: "0.7rem",
                            }}
                          >
                            Rejected
                          </span>
                        )}
                        {leave?.status === "P" && (
                          <span
                            style={{
                              backgroundColor: "rgba(255, 255, 0, 0.1)",
                              color: "#f7b12a",
                              border: "1px solid #f7b12a",
                              borderRadius: "0.2rem",
                              padding: "2px 6px",
                              fontSize: "0.7rem",
                            }}
                          >
                            Pending
                          </span>
                        )}
                        {leave?.status === "A" && (
                          <span
                            style={{
                              backgroundColor: "rgba(43, 193, 85, 0.1)",
                              color: "#2bc155",
                              border: "1px solid #2bc155",
                              borderRadius: "0.2rem",
                              padding: "2px 6px",
                              fontSize: "0.7rem",
                            }}
                          >
                            Approved
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    color: "#673F69",
                    fontSize: "1rem",
                    fontWeight: "600",
                    padding: "0.5rem",
                  }}
                >
                  No data found
                </div>
              )}

              <div className="d-flex justify-content-center mt-2">
                <Link
                  to="/admin/LeaveApprovalAdmin"
                  style={{
                    fontSize: "0.8rem",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    textDecoration: "none",
                    color: "#333",
                    padding: "4px 8px",
                    border: "1px solid #ccc",
                    borderRadius: "0.3rem",
                  }}
                >
                  <FcPrevious />
                  View More
                  <FcNext />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
    </>
  );
};

export default AdminDashboard;
